import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import { isActivityLowTech } from './ConstActivityBtns';

const HISTORY_HELP = `
  <div>
    <p><strong>Purpose:</strong> Here we’re interested in what alternative access approaches clients have tried: what’s worked, and what hasn’t. This can help you get ideas for what might work better.
    This includes experiences the client has had with computing devices: the devices they’ve used and how they’ve accessed those devices.</p>  
    <p>In the low-tech case, we won't ask about computing devices but the history of what, if anything, has been tried before is still relevant.  
    In that context, an 'access method' would be any signal the client makes to accomplish the goal (like a particular eye movement).</p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.array, //[she, her, hers]
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their']
};

//content sub-component with unique content for this page
//We could conditionally hide the computing devices item is low-tech but that seems unnecessary and maybe too cute
function IntroContent(props) {
  const {
    firstName,
    pronouns,
    isLowTech
   } = props;

  return(
    <>
    <p>This includes:</p>
    <ul>
        <li>Whether {firstName} has a current access method that {pronouns[0]} can use, and how that's going for {pronouns[1]}</li>
        <li>What other access methods {firstName} has tried, with what result</li>
        {!isLowTech && <li>What computing devices {firstName} is familiar with</li>}
    </ul>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoHistoryIntro(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const priority = props.priority;
  const onContinue = props.onContinue;
  console.log("rendering GatherInfoHistoryIntro, props: " + JSON.stringify(props));

  let title = `Consider ${firstName}'s history using access AT and other technology`;
  let lmLink = `Learn More about why we ask about History of Tech Use`;
  let lmTitle = `History of Tech Use`;

  if (isActivityLowTech(priority)){
    title = `Consider ${firstName}'s history using low or no-tech access`;
    lmLink = `Learn More about why we ask about History of Access Use`;
    lmTitle = `History of Access Use`;
  }

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",
    title: title,
    subTitle: "",
    learnMore: {linkText: lmLink,
                title: lmTitle,
                content: HISTORY_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <IntroContent 
          firstName={firstName} 
          pronouns={pronouns}
          isLowTech={isActivityLowTech(priority)}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryIntro.propTypes = propTypes;
GatherInfoHistoryIntro.defaultProps = defaultProps;

export default GatherInfoHistoryIntro;